<template>
  <div>
                        <v-data-table
                            no-data-text="Заявки отсутствуют"
                            :style="{color: $mainColor}"
                            :headers="headers"
                            :items="showAll ? allStationInHouses : stationInHouses"
                            :loading-text="$t('User.loading_orders')"
                            :items-per-page="5"
                            :footer-props="{
                                itemsPerPageOptions: [5, 15,-1],
                                itemsPerPageText: 'кол-во на стр.:',
                            }"
                        >
                          <template v-slot:top>

                            <v-container>
                              <v-row>
                                <v-col class="pt-0 pb-0">
                                    <v-btn
                                        v-if="showAll"
                                        text
                                        small
                                        target='_blank'
                                        @click="showAll = false"
                                        color="#16336e">
                                        <v-icon>mdi-chevron-up</v-icon>скрыть завершенные<v-icon>mdi-chevron-up</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        text
                                        small
                                        target='_blank'
                                        @click="showAll = true"
                                        color="#16336e">
                                        <v-icon>mdi-chevron-down</v-icon>показать завершенные<v-icon>mdi-chevron-down</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col class="pt-0 pb-0">
                                    <v-btn
                                      @click="dialogADD_EXPERIMENT = true"
                                      type="primary"
                                      outlined
                                      :color="$mainColor"
                                      x-small>
                                        Добавить внутренние работы
                                    </v-btn>
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>

                          <template v-slot:body="{ items, isSelected, select}">
                            <tbody>
                                <tr v-if="items.length == 0">
                                    <td colspan="3">
                                        <b>Записи о работах отсутствуют</b>
                                    </td>
                                </tr>
                                <tr v-else v-for="item in items" :key="item.id" :class="row_classes(item)" @click="openPopupCard(item)" style="cursor: pointer;">
                                    <td>
                                        <span>
                                            <b>{{ item.experiment_name }}
                                            </b>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <i style="font-style: italic;">{{ g.toDateTime(item.start_date) }}</i>
                                        </span>

                                    </td>
                                    <td>
                                        <span>
                                            <i style="font-style: italic;">{{ g.toDateTime(item.finish_date) }}</i>
                                        </span>

                                    </td>
                                    <td>
                                      <v-chip
                                        class=" mr-auto"
                                        style="padding:10.8px;"
                                        label
                                        dark
                                        x-small
                                        :color="item.type | colorChip">
                                        {{item.type == 1 ? 'In-house' : 'Обслуживание станции'}}
                                      </v-chip>
                                    </td>
                                    <td>
                                      <v-chip
                                        x-small
                                        outlined
                                        :color="item.is_completed | colorChipActive">
                                        {{item.is_completed ? 'archive' : 'active'}}
                                      </v-chip>
                                    </td>
                                </tr>
                            </tbody>
                          </template>
                        </v-data-table>


    <v-dialog v-model="dialogADD_EXPERIMENT" width="80%"  class='pa-4'  transition="dialog-bottom-transition"> 
          <template v-slot:default="dialog">
            <v-card>
              <v-card-title>Добавление эксперимента</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class='pa-5'>
                  <v-col cols=6>
                    <v-text-field
                      v-model="nameExperiment"
                      label="Название эксперимента"
                      :maxlength="300"
                      counter
                    ></v-text-field>
                    <v-radio-group v-model="experimentType">
                      <v-radio
                        v-for="n in experimentTypeList"
                        :label="`${n.name}`"
                        :value="n.type"
                        :key="n.type"
                      ></v-radio>
                    </v-radio-group >
                  </v-col>
                  <v-col cols=6>
                    <v-textarea
                      name="input-6-4"
                      :label="$t('comment')"
                      :color="$mainColor"
                      rows=5
                      solo
                      v-model="commentExperiment"
                      :maxlength="1000"
                      counter
                    ></v-textarea>
                  </v-col>
                </v-row>

                <div class="add-experiment">
              
                  <v-row>
                    <!-- <v-col cols="12" sm="6" md="6"> -->
                    <v-col cols="3">
                      Начало эксперимента
                      <v-menu
                        ref="menuStart"
                        v-model="menuStart"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="dateStart"
                            :label="$t('start_experiment')"
                            readonly
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :close-on-content-click="false"
                            solo
                          ></v-text-field>
                        </template>
                        <v-date-picker :color='$mainColor' v-model="dateStart"  no-title scrollable >
                          <v-spacer></v-spacer>
                          <v-btn outlined  :color='$mainColor'  @click="menuStart = false">{{$t('cancel')}}</v-btn>
                          <v-btn outlined :color='$mainColor'  @click="$refs.menuStart.save(dateStart)">{{$t('ok')}}</v-btn>
                        </v-date-picker>
                      </v-menu>

                      <v-menu
                        ref="menu"
                        v-model="menu_time"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="start_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="start_time"
                            label="Время начала"
                            prepend-icon="mdi-clock-time-four-outline"
                            :color='$mainColor' 
                            readonly
                            v-bind="attrs"
                            solo
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu_time"
                          v-model="start_time"
                          full-width
                          locale='ru'
                          :color='$mainColor' 
                          @click:minute="$refs.menu.save(start_time)"
                        >
                        <v-spacer></v-spacer>
                          <v-btn
                            outlined  :color='$mainColor' 
                            @click="menu_time = false"
                          >
                            Отмена
                          </v-btn>
                          <v-btn
                            outlined  :color='$mainColor' 
                            @click="$refs.menu.save(end_time)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>

                      </v-menu>

                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="6"> -->
                    <v-col cols="3">
                      Конец эксперимента
                      <v-menu
                        ref="menuEnd"
                        v-model="menuEnd"
                        :close-on-content-click="false"
                        :return-value.sync="dateEnd"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="dateEnd"
                            :label="$t('end_experiment')"
                            readonly
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            solo
                          ></v-text-field>
                        </template>
                        <v-date-picker :color='$mainColor' v-model="dateEnd" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn outlined :color='$mainColor'  @click="menuEnd = false">{{$t('cancel')}}</v-btn>
                          <v-btn outlined :color='$mainColor'  @click="$refs.menuEnd.save(dateEnd)">{{$t('ok')}}</v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu2"
                        v-model="menu_end_time"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="end_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="end_time"
                            label="Время начала"
                            prepend-icon="mdi-clock-time-four-outline"
                            :color='$mainColor' 
                            readonly
                            v-bind="attrs"
                            solo
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu_end_time"
                          v-model="end_time"
                          locale='ru'
                          full-width
                          :color='$mainColor' 
                          @click:minute="$refs.menu2.save(end_time)"
                        >
                        <v-spacer></v-spacer>
                          <v-btn
                            outlined  :color='$mainColor' 
                            @click="menu_end_time = false"
                          >
                            Отмена
                          </v-btn>
                          <v-btn
                            outlined  :color='$mainColor' 
                            @click="$refs.menu2.save(end_time)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-menu>

                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    :loading="loaded"
                    outlined
                    :disabled='!start_time || !end_time ||  !dateStart ||  !dateEnd || (experimentType === null)'
                    class='mb-2 mr-6'                  
                    @click="dialogConfirm = true"
                    type="primary">{{$t('InHouseList.add_experiment')}}</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        
    </v-dialog>
    <v-dialog v-model="dialogConfirm" persistent max-width="290">
      <v-card>
          <v-card-title class="headline">{{$t('InHouseList.confirmation')}}</v-card-title>
          <v-card-text>{{$t('InHouseList.want_add_experiment')}}</v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small  @click="dialogConfirm = false">{{$t('cancel')}}</v-btn>
          <v-btn small  @click="addInHouse()">{{$t("InHouseList.add")}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCalendarCard" width="60%">
      <calendar-card
        @updateParent="update_parent($event)" 
        @closeModal="close_modal($event)" 
        :InputData="popup_data"
      />
    </v-dialog>
      
  </div>
</template>

<script>

// import {errorHelper} from '../../store/helper.js'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import CalendarCard from '../Modal/CalendarCard.vue'

export default {
  name: 'InHouseTable',
  props: {
  },
  components: {
    CalendarCard,
  },
  data: () => ({
      showAll: false,
      headers: [
        { text: 'Название', sortable: true, value: 'experiment_name', width: '25%'},
        { text: 'С', sortable: true, value: 'start_date', width: '20%'},
        { text: 'По', sortable: true, value: 'finish_date', width: '20%'},
        { text: 'Тип', sortable: true, value: 'type', width: '15%'},
        { text: 'Статус', sortable: true, value: 'is_completed', width: '20%'},
      ],

      loaded: false,
      popup_data: null,
      dialogConfirm: false,
      start_time: null,
      end_time: null,
      dialogADD_EXPERIMENT: false,
      nameExperiment: '',
      menu_time:false,
      menu_end_time: false,
      experimentTypeList: [
        {name:'in-house', type: 1}, 
        {name:'обслуживание станции', type:0},
      ],
      experimentType: null,
      dateStart: new Date().toISOString().substr(0, 10),
      dateEnd: new Date().toISOString().substr(0, 10),
      menuStart: false,
      menuEnd: false,
      commentExperiment: '',
      hover: false,
      name: '',

      stationInHouses: [],
      allStationInHouses: [],
      page: 1,
      disabledLoadYet: true,        
      pageCount : 1,

      noData: false,
      dialogCalendarCard: false,
  }),

  async beforeMount() {
    this.loadInHouseList()
  },
  
  computed: {
    ...mapGetters([
      'GETTERS_CALENDAR_INIT',
      'GETTERS_STATION_INHOUSES',
      'GETTERS_CURRENT_STATION',
      'GETTERS_UPDATE_CURRENT_INHOUSE_VIEW',
    ]),
  },
  filters: {
    colorChip(val) {
      if (val == 0) 
        return '#00ffda';
      else if (val == 1) 
        return 'green';
      else 
        return 'error';
    },

    colorChipActive(val) {
      if (val) 
        return '#f6000061';
      else 
        return '#00f6317d';
    },
  },

  methods: {
    ...mapActions([
      'ADD_EXPERIMENT', 
      'GET_INHOUSE_LIST',
    ]),
    ...mapMutations([
        'UPDATE_CURRENT_CALENDAR',
        'SET_NEED_UPDATE_INHOUSE',
    ]),

    row_classes(item) {
      return ''
        // if(item.bs_resolution == 2)
        //   return "green_bg";
        // else if(item.bs_resolution == 1)
        //   return "red_bg";
        // else
        //   return "orange_bg";
    },

    formate_date(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()

      if (month<10) month = '0' + month
      if (date<10) date = '0' + date
      return date+'.'+ month+'.'+date_obj.getFullYear()
    },

    loadInHouseList(overload = false){      
      if(this.GETTERS_CALENDAR_INIT){
        var data = this.GETTERS_STATION_INHOUSES(this.GETTERS_CURRENT_STATION)

        if(!data.loaded || overload)
          this.GET_INHOUSE_LIST({station_id:this.GETTERS_CURRENT_STATION})
        else
          this.prepare_data(data.in_house)

      }
    },

    prepare_data(data){
        this.allStationInHouses = data
        this.stationInHouses = []

        this.allStationInHouses.forEach((item, i) => {
            if(item.is_completed){
                // item.color = '#93e093'
            }
            else{
                // item.color = '#ffb800'
                this.stationInHouses.push(item)
            }
        })
    },

    openPopupCard(data){
      this.popup_data = {
        name:  data.experiment_name ??  'без названия' ,
        start: this.formate_date_for_cal(data.start_date, true),
        end: this.formate_date_for_cal(data.finish_date, false),
        source: data,
        id: data.id,
        // reported: false,
        type: data.type,

      }
      this.dialogCalendarCard =true

    },

    formate_date_for_cal(str, with_one){
      var dd_cal = new Date(str)
      var min = dd_cal.getMinutes()
      if (min === 0 && with_one) min = 1
      const formatted = `${dd_cal.getFullYear()}-${(dd_cal.getMonth()+1)}-${dd_cal.getDate()} ${dd_cal.getHours()}:${min}`
      return formatted
    },

    addInHouse() {
      this.loaded = true
      
      if (this.start_time)
        var dateStart = this.dateStart.split('-').reverse().join('.') +' '+ this.start_time
      else
        var dateStart = this.dateStart.split('-').reverse().join('.') + ' 00:00'

      if (this.dateEnd)
        var dateEnd = this.dateEnd.split('-').reverse().join('.')+' '+this.end_time
      else
        var dateEnd = this.dateEnd.split('-').reverse().join('.') + ' 23:59'

      var data_add_exp = {
        name: this.nameExperiment,
        type: this.experimentType,
        station: this.GETTERS_CURRENT_STATION,
        experiment_calendar: [
        {date_start: dateStart, date_end: dateEnd}
        ],
        comments: this.commentExperiment
      }

      this.ADD_EXPERIMENT(data_add_exp)
      .then(() => {
        this.$messageHelper(this.$t('bs.successful_entry'), 'success')
        this.loaded = false
        this.experimentType = null
        this.nameExperiment = ''
        this.dateStart = this.dateEnd =  null
        this.start_time = this.end_time =  null
        this.commentExperiment = null
        this.name = null
        this.dialogADD_EXPERIMENT = false
        this.dialogConfirm = false

        this.loadInHouseList(true)
        this.UPDATE_CURRENT_CALENDAR(true)
      })
      .catch(() => {
        alert('ошибка')
        this.loaded = false
        this.dialogADD_EXPERIMENT = false
        this.dialogConfirm = false
        this.$emit('errorRecord')
      })
    },


  update_parent() {
    this.loadInHouseList(true)
    this.UPDATE_CURRENT_CALENDAR(true)
    this.close_modal()
  },

    close_modal(){
      this.dialogCalendarCard = false
    },

  },

  watch: {
    GETTERS_CURRENT_STATION(val){
        if(val){
          this.GETTERS_CURRENT_STATION = val
          this.loadInHouseList()
        }
    },
    GETTERS_CALENDAR_INIT(val) {
        if(val){
          this.loadInHouseList()
        }
    },
    GETTERS_UPDATE_CURRENT_INHOUSE_VIEW(val){
      if(val == this.GETTERS_CURRENT_STATION){
        var data = this.GETTERS_STATION_INHOUSES(this.GETTERS_CURRENT_STATION) 

        this.prepare_data(data.in_house)
        this.SET_NEED_UPDATE_INHOUSE(0);
      }
    },
  }

};

</script>

